module.exports = __webpack_public_path__ + "static/media/safariIcon.eefce732.svg";